import ServicesComponent from "../Components/homepageComponents/ServicesComponent";
// import UserInfoComponent from "../Components/homepageComponents/UserInfoComponent";
// import { useAppContext } from "../AppContext";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import {
  getInternalPortalAnnouncementsASC,
  getInternalPortalHomeSides,
} from "../api/api";
import InnerPageLayoutHome from "../Components/Layout/InnerPageLayoutHome";

function HomePage() {
  // const app = useAppContext();
  const { i18n } = useTranslation();
  // const user = app.user || { displayName: '', jobTitle: '' };
  const { isLoading, error, data, refetch }: any = useQuery(
    "HomeSliderData",
    () => getInternalPortalHomeSides({ limit: 5, language: i18n.language })
  );

  useEffect(() => {
    refetch();
  }, [i18n.language, refetch]);

  if (isLoading) return <div></div>;

  if (error) return <div></div>;

  return (
    <InnerPageLayoutHome>
       <ServicesComponent data={data} /> 
    </InnerPageLayoutHome>
  );
}

export default HomePage;
